import { useContext, useCallback, useEffect, useRef, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { HiX } from "react-icons/hi";
import { RxHamburgerMenu } from "react-icons/rx";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  FaChevronDown,
  FaChevronUp,
  FaHandHoldingUsd,
  FaStoreAlt,
} from "react-icons/fa";
import { Modal, button } from "react-bootstrap";
import { base_url } from "../utils/axiosConfig";
import { AuthContext } from "../context";
import {
  FaUserTie,
  FaUsers,
  FaUser,
  FaLock,
  FaClock,
  FaHandshake,
  FaBuilding,
  FaBriefcase,
  FaStore,
  FaChartLine,
  FaCheckCircle,
} from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";
import RoleInfoModal from "./roleModal";

const Header = () => {
  const {
    isAuthenticated,
    setIsAuthenticated,
    isAccountModalOpen,
    openAccountModal,
    closeAccountModal,
  } = useContext(AuthContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState({
    categories: [],
    subcategories: [],
    subSubcategories: [],
    subSubSubcategories: [],
    products: [],
  });
  const [showResults, setShowResults] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  // const [isAccountModalOpen, setShowAccountModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const timeoutRef = useRef(null);
  const searchInputRef = useRef(null);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const currency = localStorage.getItem("currency");

  const token = localStorage.getItem("user_website")
    ? JSON.parse(localStorage.getItem("user_website"))
    : JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user"))
      : null;

  const isWalletUser = token?.userType === "member";

  const debounce = (func, delay) => {
    return (...args) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => func(...args), delay);
    };
  };

  const fetchProducts = useCallback(async (term = "") => {
    try {
      const response = await fetch(
        `${base_url}product/getCategory?page=1&limit=100&sortingColumn=createdAt&sortingOrder=asc&search=${encodeURIComponent(
          term,
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (term) {
        let categories = [];
        let subcategories = [];
        let subSubcategories = [];
        let subSubSubcategories = [];
        let products = [];

        if (Array.isArray(data?.data) && data.data[0]?.categoryName) {
          categories = data.data;
          subcategories = categories.flatMap((cat) =>
            (cat.subCategories || []).map((sub) => ({
              ...sub,
              parentCategory: cat,
            })),
          );
          subSubcategories = subcategories.flatMap((sub) =>
            (sub.subSubCategories || []).map((subSub) => ({
              ...subSub,
              parentCategory: sub.parentCategory,
              parentSubCategory: sub,
            })),
          );
          subSubSubcategories = subSubcategories.flatMap((subSub) =>
            (subSub.subSubSubCategories || []).map((subSubSub) => ({
              ...subSubSub,
              parentCategory: subSub.parentCategory,
              parentSubCategory: subSub.parentSubCategory,
              parentSubSubCategory: subSub,
            })),
          );
          products = [
            ...categories.flatMap((cat) => cat.products || []),
            ...subcategories.flatMap((sub) => sub.products || []),
            ...subSubcategories.flatMap((subSub) => subSub.products || []),
            ...subSubSubcategories.flatMap(
              (subSubSub) => subSubSub.products || [],
            ),
          ].filter(
            (product, index, self) =>
              product && self.findIndex((p) => p._id === product._id) === index,
          );
        } else if (Array.isArray(data?.data) && data.data[0]?.subCategories) {
          subcategories = data.data.flatMap((item) =>
            (item.subCategories || []).map((sub) => ({
              ...sub,
              parentCategory: item.parentCategory || {
                categoryName: "Unknown Category",
              },
            })),
          );
          subSubcategories = subcategories.flatMap((sub) =>
            (sub.subSubCategories || []).map((subSub) => ({
              ...subSub,
              parentCategory: sub.parentCategory,
              parentSubCategory: sub,
            })),
          );
          subSubSubcategories = subSubcategories.flatMap((subSub) =>
            (subSub.subSubSubCategories || []).map((subSubSub) => ({
              ...subSubSub,
              parentCategory: subSub.parentCategory,
              parentSubCategory: subSub.parentSubCategory,
              parentSubSubCategory: subSub,
            })),
          );
          products = [
            ...subcategories.flatMap((sub) => sub.products || []),
            ...subSubcategories.flatMap((subSub) => subSub.products || []),
            ...subSubSubcategories.flatMap(
              (subSubSub) => subSubSub.products || [],
            ),
          ].filter(
            (product, index, self) =>
              product && self.findIndex((p) => p._id === product._id) === index,
          );
        } else if (
          Array.isArray(data?.data) &&
          data.data[0]?.subSubCategories
        ) {
          subSubcategories = data.data.flatMap((item) =>
            (item.subSubCategories || []).map((subSub) => ({
              ...subSub,
              parentCategory: item.parentCategory || {
                categoryName: "Unknown Category",
              },
              parentSubCategory: item.parentSubCategory || {
                subCategoryName: "Unknown Subcategory",
              },
            })),
          );
          subSubSubcategories = subSubcategories.flatMap((subSub) =>
            (subSub.subSubSubCategories || []).map((subSubSub) => ({
              ...subSubSub,
              parentCategory: subSub.parentCategory,
              parentSubCategory: subSub.parentSubCategory,
              parentSubSubCategory: subSub,
            })),
          );
          products = [
            ...subSubcategories.flatMap((subSub) => subSub.products || []),
            ...subSubSubcategories.flatMap(
              (subSubSub) => subSubSub.products || [],
            ),
          ].filter(
            (product, index, self) =>
              product && self.findIndex((p) => p._id === product._id) === index,
          );
        } else if (
          Array.isArray(data?.data) &&
          data.data[0]?.subSubSubCategories
        ) {
          subSubSubcategories = data.data.flatMap((item) =>
            (item.subSubSubCategories || []).map((subSubSub) => ({
              ...subSubSub,
              parentCategory: item.parentCategory || {
                categoryName: "Unknown Category",
              },
              parentSubCategory: item.parentSubCategory || {
                subCategoryName: "Unknown Subcategory",
              },
              parentSubSubCategory: item.parentSubSubCategory || {
                subSubCategoryName: "Unknown Sub-subcategory",
              },
            })),
          );
          products = subSubSubcategories
            .flatMap((subSubSub) => subSubSub.products || [])
            .filter(
              (product, index, self) =>
                product &&
                self.findIndex((p) => p._id === product._id) === index,
            );
        } else if (Array.isArray(data?.data) && data.data[0]?.productName) {
          products = data.data.map((product) => ({
            ...product,
            parentCategory: product.parentCategory || {
              categoryName: "Unknown Category",
            },
            parentSubCategory: product.parentSubCategory || null,
            parentSubSubCategory: product.parentSubSubCategory || null,
            parentSubSubSubCategory: product.parentSubSubSubCategory || null,
          }));
        }

        const lowerTerm = term.trim().toLowerCase();
        setSearchResults({
          categories: categories.filter(
            (cat) =>
              cat.categoryName &&
              cat.categoryName.trim().toLowerCase().includes(lowerTerm),
          ),
          subcategories: subcategories.filter(
            (sub) =>
              sub.subCategoryName &&
              sub.subCategoryName.trim().toLowerCase().includes(lowerTerm),
          ),
          subSubcategories: subSubcategories.filter(
            (subSub) =>
              subSub.subSubCategoryName &&
              subSub.subSubCategoryName
                .trim()
                .toLowerCase()
                .includes(lowerTerm),
          ),
          subSubSubcategories: subSubSubcategories.filter(
            (subSubSub) =>
              subSubSub.subSubSubCategoryName &&
              subSubSub.subSubSubCategoryName
                .trim()
                .toLowerCase()
                .includes(lowerTerm),
          ),
          products: products.filter(
            (prod) =>
              prod.productName &&
              prod.productName.trim().toLowerCase().includes(lowerTerm),
          ),
        });
        setShowResults(true);
      } else {
        setCategories(data?.data || []);
        setSearchResults({
          categories: [],
          subcategories: [],
          subSubcategories: [],
          subSubSubcategories: [],
          products: [],
        });
        setShowResults(false);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to fetch search results. Please try again.");
    }
  }, []);

  const debouncedFetchProducts = useCallback(debounce(fetchProducts, 500), [
    fetchProducts,
  ]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    if (isFilterSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFilterSidebarOpen]);

  useEffect(() => {
    if (location.state?.openChannelPartnerSignUp) {
      const timer = setTimeout(() => {
        navigate("/signup/channelpartner", { state: {}, replace: true });
      }, 500);
      return () => clearTimeout(timer);
    }

    if (location.state?.openMemberSignUp) {
      const timer = setTimeout(() => {
        navigate("/signup/member", { state: {}, replace: true });
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [location.state, navigate]);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    debouncedFetchProducts(term);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      setShowResults(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setShowResults(false);
      }
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".filter-button")
      ) {
        setIsFilterSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsFilterSidebarOpen(false);
  };

  const toggleFilterSidebar = () => {
    setIsFilterSidebarOpen(!isFilterSidebarOpen);
    setIsMenuOpen(false);
  };

  const toggleCategory = (categoryId) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  const handleSubcategorySelect = (category, subcategory) => {
    navigate(`/category/${category?._id}`, {
      state: {
        category,
        subcategory,
        products: subcategory.products,
      },
    });
    setIsFilterSidebarOpen(false);
  };

  const handleAccountClick = () => {
    openAccountModal();
  };

  const handleTypeClick = (type, action) => {
    setSelectedType(type);

    const basePath = action === "login" ? "/signin" : "/signup";
    if (type === "enduser") {
      // Direct navigation for End User
      navigate(`${basePath}/${type}`);
      if (action === "login") {
        closeAccountModal();
      }
    }
    if (action === "login") {
      if (type === "channelpartner") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/partnerlogin",
          "_blank",
        );
      } else if (type === "channelpartnerplus") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/partnerpluslogin",
          "_blank",
        );
      } else if (type === "corporate") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/corporatelogin",
          "_blank",
        );
      } else if (type === "director") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/directorlogin",
          "_blank",
        );
      } else if (type === "franchise") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/franchiselogin",
          "_blank",
        );
      } else if (type === "vendor") {
        window.open(
          "https://lifeonplus.in/dashboardPanel/vendorlogin",
          "_blank",
        );
      } else if (type === "member") {
        navigate(`${basePath}/${type}`);
      }
    }

    if (action === "register") {
      navigate(`${basePath}/${type}`);
    }
  };

  const proceedToAction = () => {
    navigate(`signup/${selectedType}`);
    setShowDetailsModal(false);
  };
  console.log(isWalletUser);
  const handleLogout = () => {
    localStorage.removeItem("user_website");
    if (isWalletUser) localStorage.removeItem("user");
    sessionStorage.clear();
    setIsAuthenticated(false);
    navigate("/", { state: { from: location.pathname } });
    setIsFilterSidebarOpen(false);
    window.location.reload();
  };

  const formatForUrl = (name) => {
    if (!name) {
      console.warn("formatForUrl received undefined or empty name");
      return "unnamed";
    }
    return name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const findCategoryHierarchyForProduct = (productId) => {
    for (const category of categories || []) {
      if (!category.categoryName) {
        console.warn(`Category with ID ${category._id} has no categoryName`);
        continue;
      }
      for (const subCategory of category.subCategories || []) {
        if ((subCategory.products || []).some((p) => p._id === productId)) {
          return {
            category,
            subCategory,
            subSubCategory: null,
            subSubSubCategory: null,
          };
        }
        for (const subSubCategory of subCategory.subSubCategories || []) {
          if (
            (subSubCategory.products || []).some((p) => p._id === productId)
          ) {
            return {
              category,
              subCategory,
              subSubCategory,
              subSubSubCategory: null,
            };
          }
          for (const subSubSubCategory of subSubCategory.subSubSubCategories ||
            []) {
            if (
              (subSubSubCategory.products || []).some(
                (p) => p._id === productId,
              )
            ) {
              return {
                category,
                subCategory,
                subSubCategory,
                subSubSubCategory,
              };
            }
          }
        }
      }
    }
    console.warn(`No hierarchy found for product ID ${productId}`);
    return {
      category: null,
      subCategory: null,
      subSubCategory: null,
      subSubSubCategory: null,
    };
  };

  const findCategoryHierarchyForSubSubCategory = (subSubCategoryId) => {
    for (const category of categories || []) {
      if (!category.categoryName) {
        console.warn(`Category with ID ${category._id} has no categoryName`);
        continue;
      }
      for (const subCategory of category.subCategories || []) {
        for (const subSubCategory of subCategory.subSubCategories || []) {
          if (subSubCategory._id === subSubCategoryId) {
            return {
              category,
              subCategory,
              subSubCategory,
              subSubSubCategory: null,
            };
          }
          for (const subSubSubCategory of subSubCategory.subSubSubCategories ||
            []) {
            if (subSubSubCategory._id === subSubCategoryId) {
              return {
                category,
                subCategory,
                subSubCategory,
                subSubSubCategory,
              };
            }
          }
        }
      }
    }
    console.warn(
      `No hierarchy found for subSubCategory ID ${subSubCategoryId}`,
    );
    return {
      category: null,
      subCategory: null,
      subSubCategory: null,
      subSubSubCategory: null,
    };
  };

  const findCategoryHierarchyForSubSubSubCategory = (subSubSubCategoryId) => {
    for (const category of categories || []) {
      if (!category.categoryName) {
        console.warn(`Category with ID ${category._id} has no categoryName`);
        continue;
      }
      for (const subCategory of category.subCategories || []) {
        for (const subSubCategory of subCategory.subSubCategories || []) {
          for (const subSubSubCategory of subSubCategory.subSubSubCategories ||
            []) {
            if (subSubSubCategory._id === subSubSubCategoryId) {
              return {
                category,
                subCategory,
                subSubCategory,
                subSubSubCategory,
              };
            }
          }
        }
      }
    }
    console.warn(
      `No hierarchy found for subSubSubCategory ID ${subSubSubCategoryId}`,
    );
    return {
      category: null,
      subCategory: null,
      subSubCategory: null,
      subSubSubCategory: null,
    };
  };

  return (
    <>
      <header className="bg-white shadow-sm z-20 sticky top-0">
        <div className="px-4 md:px-4 flex flex-col md:flex-row justify-between items-center gap-4 py-2">
          <div className="flex items-center justify-between w-full md:w-auto">
            <div className="flex items-center gap-2 md:gap-3">
              <img
                className="cursor-pointer h-10 md:h-12"
                src="/lifeon.svg"
                alt="logo"
                height="40"
                onClick={() =>
                  navigate("/", { state: { from: location.pathname } })
                }
              />
            </div>
            <button
              className="md:hidden text-gray-600 focus:outline-none"
              onClick={toggleMenu}
            >
              <RxHamburgerMenu size={28} />
            </button>
          </div>

          {/* <div
            className="w-[300px] relative"
            ref={searchInputRef}
          >
            <form onSubmit={handleSubmit}>
              <BsSearch
                className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                size={16}
                onClick={handleSubmit}
              />
              <input
                type="text"
                className="w-[300px] pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-full focus:outline-none"
                placeholder="Search for categories, subcategories, or products"
                value={searchTerm}
                onChange={handleInputChange}
                onFocus={() => searchTerm && setShowResults(true)}
              />
            </form>

            {showResults && (
              <div className="absolute top-full left-0 w-full max-w-[calc(100vw-1rem)] bg-white border border-gray-200 rounded-lg shadow-lg mt-2 z-50 max-h-80 overflow-y-auto">
                {searchResults.categories?.length === 0 &&
                  searchResults.subcategories?.length === 0 &&
                  searchResults.subSubcategories?.length === 0 &&
                  searchResults.subSubSubcategories?.length === 0 &&
                  searchResults.products?.length === 0 && (
                    <div className="px-4 py-2 text-sm text-gray-500">
                      {searchTerm
                        ? "No results found"
                        : "Start typing to search"}
                    </div>
                  )}

                {searchResults.categories?.length > 0 && (
                  <div className="border-b border-gray-200">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500">
                      Categories
                    </div>
                    {searchResults.categories.map((category) => (
                      <div
                        key={category._id}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                        onClick={() => {
                          const categoryName =
                            category.categoryName || "Unnamed Category";
                          navigate(`/category/${formatForUrl(categoryName)}`, {
                            state: {
                              category,
                              subCategory: null,
                              subSubCategory: null,
                              subSubSubCategory: null,
                            },
                          });
                          setShowResults(false);
                          setSearchTerm("");
                        }}
                      >
                        {category.images?.[0] && (
                          <img
                            src={category.images[0]}
                            alt={category.categoryName || "Category"}
                            className="w-10 h-10 object-cover rounded"
                            onError={(e) => (e.target.src = "/placeholder.png")}
                          />
                        )}
                        <div>
                          <p className="text-sm font-semibold">
                            {category.categoryName || "Unnamed Category"}
                          </p>
                          <p className="text-xs text-gray-500 line-clamp-1">
                            {category.description || "No description available"}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {searchResults.subcategories?.length > 0 && (
                  <div className="border-b border-gray-200">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500">
                      Subcategories
                    </div>
                    {searchResults.subcategories.map((subcategory) => {
                      const parentCategoryName =
                        subcategory.parentCategory?.categoryName ||
                        "Unnamed Category";
                      return (
                        <div
                          key={subcategory._id}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                          onClick={() => {
                            if (
                              !parentCategoryName ||
                              !subcategory.subCategoryName
                            ) {
                              console.warn(
                                `Skipping navigation for subcategory ${subcategory._id}: missing fields`,
                                { subcategory },
                              );
                              toast.error(
                                "Unable to navigate: Missing category or subcategory name",
                              );
                              return;
                            }
                            const path = `/category/${formatForUrl(
                              parentCategoryName,
                            )}/${formatForUrl(subcategory.subCategoryName)}`;
                            navigate(path, {
                              state: {
                                category: subcategory.parentCategory,
                                subCategory: subcategory,
                                subSubCategory: null,
                                subSubSubCategory: null,
                              },
                            });
                            setShowResults(false);
                            setSearchTerm("");
                          }}
                        >
                          {subcategory.images?.[0] && (
                            <img
                              src={subcategory.images[0]}
                              alt={subcategory.subCategoryName || "Subcategory"}
                              className="w-10 h-10 object-cover rounded"
                              onError={(e) =>
                                (e.target.src = "/placeholder.png")
                              }
                            />
                          )}
                          <div>
                            <p className="text-sm font-semibold">
                              {subcategory.subCategoryName ||
                                "Unnamed Subcategory"}
                            </p>
                            <p className="text-xs text-gray-500 line-clamp-1">
                              {subcategory.description ||
                                "No description available"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {searchResults.subSubcategories?.length > 0 && (
                  <div className="border-b border-gray-200">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500">
                      Sub-subcategories
                    </div>
                    {searchResults.subSubcategories.map((subSubcategory) => {
                      const hierarchy = findCategoryHierarchyForSubSubCategory(
                        subSubcategory._id,
                      );
                      const parentCategoryName =
                        hierarchy.category?.categoryName ||
                        subSubcategory.parentCategory?.categoryName ||
                        "Unnamed Category";
                      const parentSubCategoryName =
                        hierarchy.subCategory?.subCategoryName ||
                        subSubcategory.parentSubCategory?.subCategoryName ||
                        "Unnamed Subcategory";
                      return (
                        <div
                          key={subSubcategory._id}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                          onClick={() => {
                            if (
                              !parentCategoryName ||
                              !parentSubCategoryName ||
                              !subSubcategory.subSubCategoryName
                            ) {
                              console.warn(
                                `Skipping navigation for subSubcategory ${subSubcategory._id}: missing fields`,
                                { subSubcategory },
                              );
                              toast.error(
                                "Unable to navigate: Missing category or subcategory names",
                              );
                              return;
                            }
                            const path = `/category/${formatForUrl(
                              parentCategoryName,
                            )}/${formatForUrl(
                              parentSubCategoryName,
                            )}/${formatForUrl(
                              subSubcategory.subSubCategoryName,
                            )}`;
                            navigate(path, {
                              state: {
                                category:
                                  hierarchy.category ||
                                  subSubcategory.parentCategory,
                                subCategory:
                                  hierarchy.subCategory ||
                                  subSubcategory.parentSubCategory,
                                subSubCategory:
                                  hierarchy.subSubCategory || subSubcategory,
                                subSubSubCategory: null,
                              },
                            });
                            setShowResults(false);
                            setSearchTerm("");
                          }}
                        >
                          {subSubcategory.images?.[0] && (
                            <img
                              src={subSubcategory.images[0]}
                              alt={
                                subSubcategory.subSubCategoryName ||
                                "Sub-subcategory"
                              }
                              className="w-10 h-10 object-cover rounded"
                              onError={(e) =>
                                (e.target.src = "/placeholder.png")
                              }
                            />
                          )}
                          <div>
                            <p className="text-sm font-semibold">
                              {subSubcategory.subSubCategoryName ||
                                "Unnamed Sub-subcategory"}
                            </p>
                            <p className="text-xs text-gray-500 line-clamp-1">
                              {subSubcategory.description ||
                                "No description available"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {searchResults.subSubSubcategories?.length > 0 && (
                  <div className="border-b border-gray-200">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500">
                      Sub-sub-subcategories
                    </div>
                    {searchResults.subSubSubcategories.map(
                      (subSubSubcategory) => {
                        const hierarchy =
                          findCategoryHierarchyForSubSubSubCategory(
                            subSubSubcategory._id,
                          );
                        const parentCategoryName =
                          hierarchy.category?.categoryName ||
                          subSubSubcategory.parentCategory?.categoryName ||
                          "Unnamed Category";
                        const parentSubCategoryName =
                          hierarchy.subCategory?.subCategoryName ||
                          subSubSubcategory.parentSubCategory
                            ?.subCategoryName ||
                          "Unnamed Subcategory";
                        const parentSubSubCategoryName =
                          hierarchy.subSubCategory?.subSubCategoryName ||
                          subSubSubcategory.parentSubSubCategory
                            ?.subSubCategoryName ||
                          "Unnamed Sub-subcategory";
                        return (
                          <div
                            key={subSubSubcategory._id}
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                            onClick={() => {
                              if (
                                !parentCategoryName ||
                                !parentSubCategoryName ||
                                !parentSubSubCategoryName ||
                                !subSubSubcategory.subSubSubCategoryName
                              ) {
                                console.warn(
                                  `Skipping navigation for subSubSubcategory ${subSubSubcategory._id}: missing fields`,
                                  { subSubSubcategory },
                                );
                                toast.error(
                                  "Unable to navigate: Missing category or subcategory names",
                                );
                                return;
                              }
                              const path = `/category/${formatForUrl(
                                parentCategoryName,
                              )}/${formatForUrl(
                                parentSubCategoryName,
                              )}/${formatForUrl(
                                parentSubSubCategoryName,
                              )}/${formatForUrl(
                                subSubSubcategory.subSubSubCategoryName,
                              )}`;
                              navigate(path, {
                                state: {
                                  category:
                                    hierarchy.category ||
                                    subSubSubcategory.parentCategory,
                                  subCategory:
                                    hierarchy.subCategory ||
                                    subSubSubcategory.parentSubCategory,
                                  subSubCategory:
                                    hierarchy.subSubCategory ||
                                    subSubSubcategory.parentSubSubCategory,
                                  subSubSubCategory:
                                    hierarchy.subSubSubCategory ||
                                    subSubSubcategory,
                                },
                              });
                              setShowResults(false);
                              setSearchTerm("");
                            }}
                          >
                            {subSubSubcategory.images?.[0] && (
                              <img
                                src={subSubSubcategory.images[0]}
                                alt={
                                  subSubSubcategory.subSubSubCategoryName ||
                                  "Sub-sub-subcategory"
                                }
                                className="w-10 h-10 object-cover rounded"
                                onError={(e) =>
                                  (e.target.src = "/placeholder.png")
                                }
                              />
                            )}
                            <div>
                              <p className="text-sm font-semibold">
                                {subSubSubcategory.subSubSubCategoryName ||
                                  "Unnamed Sub-sub-subcategory"}
                              </p>
                              <p className="text-xs text-gray-500 line-clamp-1">
                                {subSubSubcategory.description ||
                                  "No description available"}
                              </p>
                            </div>
                          </div>
                        );
                      },
                    )}
                  </div>
                )}

                {searchResults.products?.length > 0 && (
                  <div>
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500">
                      Products
                    </div>
                    {searchResults.products.map((product) => {
                      const hierarchy = findCategoryHierarchyForProduct(
                        product._id,
                      );
                      const parentCategoryName =
                        hierarchy.category?.categoryName ||
                        product.parentCategory?.categoryName ||
                        "Unnamed Category";
                      return (
                        <div
                          key={product._id}
                          className="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3"
                          onClick={() => {
                            const path = `/product-details/${product._id}`;
                            navigate(path, {
                              state: {
                                product,
                                category:
                                  hierarchy.category || product.parentCategory,
                                subCategory:
                                  hierarchy.subCategory ||
                                  product.parentSubCategory,
                                subSubCategory:
                                  hierarchy.subSubCategory ||
                                  product.parentSubSubCategory,
                                subSubSubCategory:
                                  hierarchy.subSubSubCategory ||
                                  product.parentSubSubSubCategory,
                              },
                            });
                            setShowResults(false);
                            setSearchTerm("");
                          }}
                        >
                          {product.variations?.[0]?.images?.[0] ||
                            (product?.images?.[0] && (
                              <img
                                src={
                                  product?.variations?.[0]?.images[0] ||
                                  product?.images?.[0]
                                }
                                alt={product?.productName || "Product"}
                                className="w-10 h-10 object-cover rounded"
                                onError={(e) =>
                                  (e.target.src = "/placeholder.png")
                                }
                              />
                            ))}
                          <div>
                            <p className="text-sm font-semibold">
                              {product.productName || "Unnamed Product"}
                            </p>
                            <p className="text-xs text-gray-500 line-clamp-1">
                              {product.briefDescription ||
                                "No description available"}
                            </p>
                            {product.variations?.[0]?.price?.amount && (
                              <p className="text-xs text-gray-600">
                                ₹{product.variations[0].price.amount}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div> */}
          <div className="hidden md:flex items-center">
            {/* Navigation links with active highlighting */}
            <nav className="flex items-center gap-1 text-sm font-medium text-gray-700">
              {[
                { path: "/", label: "Home" },
                { path: "/shop", label: "Shop" },
                { path: "/services", label: "Services" },
                // { path: "/testimonial-page", label: "Testimonials" },
                // { label: "News & Events", path: "/news-events" },
                // { label: "Gallery", path: "/gallery" },
                // { label: "Press Media", path: "/press-media" },
                { path: "/contact", label: "Contact Us" },
                { path: "/blog", label: "Blogs" },
              ].map((item) => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`mx-2 p-2 rounded transition-all ${
                    location.pathname === item.path
                      ? "bg-green-100 text-[#35A93E] underline underline-offset-4 font-medium"
                      : "hover:text-[#35A93E] hover:bg-green-50/60"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="hidden md:flex items-center gap-2 lg:gap-3">
            {isAuthenticated ? (
              <>
                <a href="/cart" className="relative">
                  <span className="text-2xl text-gray-600 hover:text-[#35A93E]">
                    🛒
                  </span>
                  Cart
                </a>
                <a href="/order-history" className="relative">
                  <span className="text-2xl text-gray-600 hover:text-[#35A93E]">
                    📋
                  </span>
                  Order
                </a>
                {!isWalletUser && (
                  <a href="/profile" className="relative">
                    <span className="text-2xl text-gray-600 hover:text-[#35A93E]">
                      👤
                    </span>
                    Profile
                  </a>
                )}
                <button
                  className="text-white text-xs md:text-sm bg-[#35A93E] hover:bg-[#2e8b36] no-underline border-none cursor-pointer px-4 py-[7px] rounded"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            ) : (
              <div className="flex items-center gap-1 md:gap-2 text-xs md:text-sm">
                <button
                  className="flex flex-row justify-center items-center w-[90px] text-white sm:w-[80px] md:w-[100px] h-[40px] sm:h-[37px] md:h-[40px] bg-[#02BE0F] rounded-[2px] px-[8px] sm:px-[10px] gap-[8px] sm:gap-[10px]"
                  onClick={handleAccountClick}
                >
                  Account
                </button>
              </div>
            )}
          </div>
        </div>

        {/* {location.pathname === "/" && currency && (
          <nav className="hidden w-full bg-[#061939] py-3 px-4 md:px-6 md:flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 lg:gap-10 text-white font-['Poppins'] font-medium text-xs leading-[18px] sm:leading-[21px] z-10">
            <div
              className="flex flex-row items-center gap-1 cursor-pointer hover:opacity-80 filter-button"
              onClick={toggleFilterSidebar}
            >
              <span>Filter</span>
              <FaChevronDown size={12} />
            </div>

            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 lg:gap-8 xl:gap-12 text-center">
              {categories?.slice(0, 6)?.map((category) => (
                <div
                  key={category?._id}
                  className="flex flex-row items-center gap-0.5 cursor-pointer"
                  onClick={() => {
                    const categoryName =
                      category.categoryName || "Unnamed Category";
                    navigate(`/category/${formatForUrl(categoryName)}`, {
                      state: {
                        category,
                        subCategory: null,
                        subSubCategory: null,
                        subSubSubCategory: null,
                      },
                    });
                  }}
                >
                  <span>{category?.categoryName || "Unnamed Category"}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-row items-center gap-0.5 cursor-pointer hover:opacity-80">
              <span>Support</span>
            </div>
          </nav>
        )} */}
      </header>

      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${
          isFilterSidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={toggleFilterSidebar}
      ></div>

      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-80 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isFilterSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between py-3 px-4 bg-[#061939] text-white">
          <h2 className="text-lg font-semibold flex-1">Filters</h2>
          <button
            className="text-white focus:outline-none"
            onClick={toggleFilterSidebar}
          >
            <HiX size={24} />
          </button>
        </div>
        <div className="p-4 overflow-y-auto h-[calc(100%-4rem)]">
          {categories?.map((category) => (
            <div key={category._id} className="mb-4">
              <div
                className="flex items-center justify-between cursor-pointer py-2"
                onClick={() => toggleCategory(category._id)}
              >
                <span className="text-sm font-medium text-gray-800">
                  {category.categoryName || "Unnamed Category"}
                </span>
                {expandedCategories[category._id] ? (
                  <FaChevronUp className="text-gray-600" size={12} />
                ) : (
                  <FaChevronDown className="text-gray-600" size={12} />
                )}
              </div>
              {expandedCategories[category._id] && (
                <div className="ml-4">
                  {category.subCategories.map((subcategory) => (
                    <div
                      key={subcategory._id}
                      className="py-2 text-sm text-gray-600 hover:text-[#35A93E] cursor-pointer"
                      onClick={() =>
                        handleSubcategorySelect(category, subcategory)
                      }
                    >
                      {subcategory.subCategoryName || "Unnamed Subcategory"}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } md:hidden`}
      >
        <div className="flex justify-end p-4">
          <button
            onClick={toggleMenu}
            className="text-gray-600 focus:outline-none"
          >
            <HiX size={24} />
          </button>
        </div>
        <div className="flex flex-col p-4 space-y-5">
          <div className="flex flex-col space-y-3 border-b pb-5">
            {[
              { path: "/", label: "Home" },
              { path: "/shop", label: "Shop" },
              { path: "/services", label: "Services" },
              // { path: "/testimonial-page", label: "Testimonials" },
              // { label: "News & Events", path: "/news-events" },
              // { label: "Gallery", path: "/gallery" },
              // { label: "Press Media", path: "/press-media" },
              { path: "/contact", label: "Contact Us" },
              { path: "/blog", label: "Blogs" },
            ].map((item) => (
              <button
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  setIsMenuOpen(false);
                }}
                className={`text-left py-2 px-3 rounded transition-all ${
                  location.pathname === item.path
                    ? "bg-green-100 text-[#35A93E] underline underline-offset-4 font-medium"
                    : "text-gray-800 hover:text-[#35A93E] hover:bg-green-50/40"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          {isAuthenticated ? (
            <div className="flex flex-col space-y-4">
              <a
                href="/cart"
                className="flex items-center gap-2 text-gray-800 text-sm hover:text-[#35A93E] no-underline"
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="text-xl">🛒</span>
                Cart
              </a>
              <a
                href="/order-history"
                className="flex items-center gap-2 text-gray-800 text-sm hover:text-[#35A93E] no-underline"
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="text-xl">📋</span>
                Orders
              </a>
              <button
                className="text-gray-800 text-sm hover:text-[#35A93E] no-underline text-left"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          ) : (
            <div className="flex flex-col space-y-4">
              <button
                onClick={handleAccountClick}
                className="flex flex-row justify-center items-center w-[120px] text-white sm:w-[140px] md:w-[171px] h-[40px] sm:h-[45px] md:h-[49px] bg-[#02BE0F] rounded-[2px] px-[8px] sm:px-[10px] gap-[8px] sm:gap-[10px]"
              >
                Account
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Account Selection Modal */}
      <Modal
        show={isAccountModalOpen}
        onHide={() => closeAccountModal()}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Choose Your Account Type</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 py-4">
          <div className="row g-4">
            {/* ACTIVE ACCOUNTS */}
            {[
              {
                title: "Member",
                icon: <FaUsers />,
                desc: "Shop products, track orders and enjoy member benefits.",
                type: "member",
                bg: "#e9f9ee",
                color: "#02BE0F",
                knowMore: true,
              },
              {
                title: "Channel Partner",
                icon: <FaHandshake />,
                desc: "For distributors and sales partners to grow business with us.",
                type: "channelpartner",
                bg: "#e7f1ff",
                color: "#0d6efd",
                knowMore: true,
              },
              {
                title: "Channel Partner Plus",
                icon: <FaUserTie />,
                desc: "Premium partners with higher commission and priority support.",
                type: "channelpartnerplus",
                bg: "#fff4e5",
                color: "#ff9800",
                knowMore: true,
              },
              {
                title: "Corporates & Industries & Professionals",
                icon: <FaBuilding />,
                desc: "For companies and professionals buying in bulk or services.",
                type: "corporate",
                bg: "#f3e8ff",
                color: "#6f42c1",
                knowMore: true,
              },
              {
                title: "Director / Super Distributor",
                icon: <FaBriefcase />,
                desc: "Manage distribution network and oversee partner operations.",
                type: "director",
                bg: "#f1f3f5",
                color: "#343a40",
                knowMore: true,
              },
              {
                title: "Vendor",
                icon: <FaStore />,
                desc: "Sell your products and manage inventory through our platform.",
                type: "vendor",
                bg: "#e6fffa",
                color: "#20c997",
                knowMore: true,
              },
              {
                title: "Franchise",
                icon: <FaStoreAlt />,
                desc: "For distributors and sales partners to grow business with us.",
                type: "franchise",
                bg: "#e7f1ff",
                color: "#0d6efd",
                knowMore: true,
              },
              {
                title: "End User",
                icon: <FaUser />,
                desc: "Purchase and use products/services directly from platform.",
                type: "enduser",
                bg: "#f8f9fa",
                color: "#6c757d",
                knowMore: true,
              },
              {
                title: "Investor",
                icon: <FaHandHoldingUsd />,
                desc: "Invest in LifeOnPlus and be part of India’s digital healthcare growth.",
                type: "investor",
                bg: "#f0fdf4",
                color: "#15803d",
              },
            ].map((item) => (
              <div className="col-md-3" key={item.title}>
                <div
                  className="border rounded-4 p-4 h-100 d-flex flex-column shadow-sm"
                  style={{
                    transition: "0.3s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 20px rgba(0,0,0,0.08)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "";
                  }}
                >
                  <h5 className="mb-2 d-flex align-items-center gap-2">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "35px",
                        height: "35px",
                        background: item.bg,
                        color: item.color,
                        fontSize: "15px",
                      }}
                    >
                      {item.icon}
                    </div>
                    <p className="text-sm">{item.title}</p>
                  </h5>

                  <p className="text-xs flex-grow-1 mb-2">{item.desc}</p>

                  {item.knowMore && (
                    <p
                      className="text-xs text-primary text-decoration-underline mb-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setShowModal(true);
                        setSelectedType(item.type);
                      }}
                    >
                      Click here to know more
                    </p>
                  )}

                  <div className="d-flex gap-2 mt-auto">
                    <button
                      className="flex text-sm justify-center items-center w-[80px] h-[30px]  bg-[#02BE0F] text-white rounded  hover:bg-[#029e0c] transition duration-200"
                      onClick={() => handleTypeClick(item.type, "register")}
                    >
                      Register
                    </button>
                    {item.type !== "investor" && (
                      <button
                        className="flex text-sm justify-center items-center w-[80px] h-[30px] border border-[#02BE0F] text-[#02BE0F] bg-white rounded"
                        onClick={() => handleTypeClick(item.type, "login")}
                      >
                        Login
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* COMING SOON */}
            {[
              { label: "Affiliate", icon: <FaHandshake /> },
              // { label: "Investor", icon: <FaChartLine /> },
              // { label: "Franchise", icon: <FaStoreAlt /> },
            ].map((item) => (
              <div className="col-md-3" key={item.label}>
                <div className="border rounded-4 p-4 h-100 d-flex flex-column shadow-sm opacity-75">
                  <h5 className="mb-2 d-flex align-items-center gap-2">
                    <FaLock className="text-secondary" size={18} />
                    <span style={{ fontSize: "24px" }}>{item.icon}</span>
                    {item.label}

                    <span className="badge bg-warning text-dark ms-auto d-flex align-items-center">
                      <FaClock className="me-1" size={12} />
                      Coming Soon
                    </span>
                  </h5>

                  <p className="text-muted small flex-grow-1 mb-4">
                    This account type will be available soon. Stay tuned!
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button variant="secondary" onClick={() => closeAccountModal()}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
      <RoleInfoModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        role={selectedType}
      />

      <style>
        {`
          .modal-90w {
            width: 90%;
            max-width: 800px;
            margin: auto;
          }
          .modal-80w {
            width: 80%;
            max-width: 500px;
            margin: auto;
          }
          @media (min-width: 768px) {
            .modal-md {
              max-width: 400px;
            }
            .modal-lg {
              max-width: 700px;
            }
          }
          .modern-input {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 12px 16px;
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            transition: all 0.2s ease;
            outline: none;
          }
          .modern-input:hover {
            border-color: #a3a3a3;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
          }
          .modern-input:focus {
            border-color: #35A93E;
            box-shadow: 0 0 0 3px rgba(53, 169, 62, 0.2);
          }
          .modern-input:disabled, .modern-input[readonly] {
            background-color: #f3f4f6;
            cursor: not-allowed;
            box-shadow: none;
          }
          @media (max-width: 767px) {
            header {
              margin-left: 0;
              margin-right: 0;
            }
            .mx-5 {
              margin-left: 0;
              margin-right: 0;
            }
            .absolute.top-full {
              width: 100%;
              max-height: 60vh;
            }
            .absolute.top-full img {
              width: 8vw;
              height: 8vw;
            }
            .absolute.top-full p {
              font-size: 3vw;
            }
              
          }

        `}
      </style>
    </>
  );
};

export default Header;
